export const en = {
    tokenNotPresentText: "Token Not present",
    messageSendError: `The chat link you are trying to access has expired.\n
    Please note that our chat links are valid for a limited duration only`,
}